import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TokenService } from '../../../services/token.service';
import { Meta } from '@angular/platform-browser';
import { navigationViews, UpdateService } from '../../../services/update.service';

@Component({
	selector: 'app-home',
	templateUrl: 'home.component.html',
	styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
	@ViewChild('heroVideo', { static: true }) heroVideo!: ElementRef<HTMLVideoElement>;

	constructor(
		private _tokenService: TokenService,
		private _router: Router,
		private _updateService: UpdateService,
		private _meta: Meta
	) {
		// On home page, redirect to the app dashboard if already logged in
		if (this._tokenService.isAuthenticated()) {
			this._router.navigate(['MyDashboard']);
		}

		this._meta.updateTag({ name: 'description',
			content: 'CropManage is a crop management web application developed ' +
			'by UCANR which help farmers manage irrigation and fertilization scheduling.'})
	}

	ngOnInit(): void {
		this._updateService.setCurrentPage(navigationViews.HOME);
	}

	ngAfterViewInit() {
		let videoElement: HTMLVideoElement;
		videoElement = this.heroVideo.nativeElement;

		// Force muted (autoplay requires this)
		videoElement.muted = true;

		// Try to start it
		requestAnimationFrame(() => videoElement.play().catch(() => { }));
	}
}
